import { Layers } from 'lucide-react';

// 2026-10-31 — Global Yearly + Global Quarterly share one roster.
export const SharedScoreboardsNote = ({ team, testid, className = '' }) => {
  if (!team?.shared_scoreboards) return null;
  return (
    <p
      className={`flex items-start gap-1.5 text-[11px] leading-snug text-muted-foreground ${className}`}
      data-testid={testid}
    >
      <Layers className="h-3.5 w-3.5 mt-px shrink-0 text-[hsl(var(--accent))]" />
      <span>
        <span className="font-semibold text-foreground">One team, two scoreboards.</span>{' '}
        Changes here update both Global Yearly and Global Quarterly.
      </span>
    </p>
  );
};
